import { ECOM_APP_DEF_ID, ECOM_CART_SECTION_ID } from '../const';
export async function isCartEnabled(wixCodeApi, bookingsSettings) {
  var _bookingsSettings$car;
  if ((_bookingsSettings$car = bookingsSettings.cartCheckout) != null && _bookingsSettings$car.enabled) {
    return wixCodeApi.site.isAppSectionInstalled({
      sectionId: ECOM_CART_SECTION_ID,
      appDefinitionId: ECOM_APP_DEF_ID
    });
  }
  return false;
}
//# sourceMappingURL=isCartEnabled.js.map